// https://lincolnprofilev9.cms.dealer.com/2026-lincoln-nautilus.htm
export default {
	events: {
		widgetUserEvent: [
			{
				logic: ({ eventData }) => {
					const { result, widgetName } = eventData;

					return (
						result === 'Opens gallery modal' &&
						widgetName === 'ws-media-viewer'
					);
				},
				payload: ({ eventData }) => ({
					directCall: 'global-onclick',
					payload: {
						onclick: {
							onclick: `vehicle:action:photo click:${
								eventData?.widgetIntention === 'exterior photos'
									? 'exterior'
									: 'interior'
							}`,
							onclickLinkName:
								'vehicle:content:action:lincoln nautilus'
						},
						vehicle: {
							modelYear: '2026',
							nameplate: 'lincoln nautilus'
						}
					}
				})
			}
		],
		'ddc.link.generic': [
			{
				logic: ({ eventData }) =>
					eventData?.attributes?.class?.includes?.(
						'schedule-test-drive'
					),
				payload: () => ({
					directCall: 'global-onclick',
					payload: {
						onclick: {
							onclick: 'vehicle:action:schedule test drive',
							onclickLinkName:
								'vehicle:content:action:2026 lincoln nautilus'
						},
						vehicle: {
							modelYear: '2026',
							nameplate: 'lincoln nautilus'
						}
					}
				})
			},

			{
				logic: ({ eventData }) =>
					eventData?.attributes?.class?.includes?.(
						'search-inventory'
					),
				payload: () => ({
					directCall: 'global-onclick',
					payload: {
						onclick: {
							onclick: 'vehicle:action:search inventory',
							onclickLinkName:
								'vehicle:content:action:2026 lincoln nautilus'
						},
						vehicle: {
							modelYear: '2026',
							nameplate: 'lincoln nautilus'
						}
					}
				})
			}
		]
	}
};
